import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography} from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { useSnackbar } from 'notistack';
import { updateSecurityAgainstApi, addSecurityAgainstApi } from '../apiServices';
import {PageLoader} from "../../../../shared_elements";
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const SecurityAgainstCRU = ({ securityAgainstCRU, modeType, getResponseBack, onToggleModal, params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [securityAgainst, setSecurityAgainst] = useState(securityAgainstCRU?.data);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const onFieldChange = (keyParam, value) => {
        setSecurityAgainst({ ...securityAgainst, [keyParam]: value });

    }
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const onAddEditSecurityAgainstFn = () => {
        let validationInputs = {};
        validationInputs = {
            name: securityAgainst?.name?.trim() ? "" : "Please enter Name",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (securityAgainst?.id) {
                globalPutService(updateSecurityAgainstApi({ slug: securityAgainst?.slug }), securityAgainst)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Security Against`, success_msg: response?.data?.message, item_id: securityAgainst?.id, payload: securityAgainst, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Security Against`, error_msg: response?.data?.message, item_id: securityAgainst?.id, payload: securityAgainst, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addSecurityAgainstApi(), securityAgainst).then((response) => {
                    if (checkApiStatus(response)) {
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Security Against`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: securityAgainst, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Security Against`, error_msg: response?.data?.message, item_id: null, payload: securityAgainst, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Security Against`, error_msg: validationInputs, })
        }
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Security Against`, page_type: page_type, })
    }

    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="md" open={true} fullWidth >
                <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === "add" ? "Add Security Against" : modeType === "edit" ? "Edit Security Against" : "View Security Against"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                required
                                id="name"
                                label="Name"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.name || false}
                                helperText={error?.name || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={securityAgainst?.name || ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value?.length <= 100 ? onFieldChange("name", e.target.value.trimStart()) : null : e.preventDefault() }
                                onFocus={() => onRestErrorKey("name")}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={securityAgainst?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    rows={3}
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    value={securityAgainst?.remarks || ""}
                                    fullWidth
                                    multiline
                                    disabled={modeType === "view"}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault(); }}
                                />
                            </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> {modeType === "view" ? "Close": "Cancel"} </Button>
                    {modeType === "view" ? null : <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditSecurityAgainstFn() }} > SAVE </Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default SecurityAgainstCRU